export default "__VITE_ASSET__6e301e28__"